import IAMReferenceCard from './IAMReferenceCard';

export default IAMReferenceCard;
